import {css} from 'lit'; export default css`:host{align-items:center;display:flex;justify-content:center;width:100vw;height:100vh}.check-icon{--goto-icon-color:var(--goto-green-500)}`;
    